import React from "react";
import { useState, useEffect } from "react";
import { Row } from "reactstrap";
import { QuizContent } from "../quiz/QuesstionContent";
import OpenButton from "../../components/buttons/OpenButton";
import SimpleModal from "../../components/modals/SimpleModal";
import { Speaking } from "../quiz/speaking";
import { ShowQuestions } from "../quiz/ShowQuestions";
import { TextArea } from "./../../components/writting_essay/textarea";
import { exerciseType } from "../../components/constants/constants";
import { size, find } from "lodash";
import { isB2C } from "../../libs/env";

export const QuizAssessmentBody = ({
  isOpenAdditionalResourceModal,
  setOpenAdditionalResourceModal,
  exercise,
  isReview,
  setIsonRecorder,
  additionalResourceToggle,
  setSpeakingUrl,
  currentPage,
  resetAudio,
  setresetAudio,
  onblur,
  answers,
  section_id,
  page_id,
  data,
  visualizerToggle,
}) => {
  let found_section = find(answers, ["section_id", section_id]);
  let found_page = find(answers, ["page_id", page_id]);
  let found_exercise = find(answers, ["exercise_id", exercise.id]);
  let [wordsCounter, setWordsCount] = useState(0
  );
  let [Answerslength, setAnswerslength] = useState();
  useEffect(()=>{
    setAnswerslength(answers.length === 0 ? 0 : 0)
     setWordsCount(
      found_section &&
        found_page &&
        found_exercise &&
        found_section.answers &&
        typeof found_section.answers === "string" &&
        exercise.task_type === exerciseType.WRITING_TASK
        ? found_section.answers.replace(/[\n]/g, " ").trim().split(" ").length
        : 0
    );
  },[answers, found_section, found_page, found_exercise, exercise])
  const handleCopyPaste = (e) => {
    if(isB2C.some(domain => window.location.origin.includes(domain)))
    {
      if(!exercise.allow_copy_paste)
      {
        e.preventDefault();
      }
    }
    else if (data && !data.allow_copy_paste) {
      e.preventDefault();
    }
  };
  let words_count, written_text;
  const textarea_change = (e) => {
    written_text = e.target.value;
    answers = written_text;
    words_count = written_text.replace(/[\n]/g, " ").trim().split(" ").length;
    setAnswerslength(words_count);
    if (!written_text) {
      words_count = 0;
    }
    setWordsCount(words_count);
  };
  let text_area_date = null;
  if (found_section && found_page && found_exercise) {
    text_area_date = found_section.answers;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Row className="bg-white border border-top-0 border-bottom-0 px-4">
        <QuizContent
          data={exercise}
          studentid={data.school_student_id}
          studentAssessmentId={data.student_assessment_id}
          datatype={data.type}
          visualizerToggle={visualizerToggle}
        />
      </Row>
      <Row
        className={
          size(exercise.additional_resource) <= 0
            ? ""
            : "border  bg-white border-top-0 border-bottom-0 px-4 p-3"
        }
      >
        {size(exercise.additional_resource) <= 0 ? (
          ""
        ) : (
          <div>
            <p className="quiz-bottom-border mb-3"></p>
            <span class="mt-3 mb-3">
              <strong> Additional question resource </strong>
              <OpenButton
                onClick={() =>
                  setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal)
                }
              />
            </span>
            <p className="quiz-bottom-border mt-3"></p>
          </div>
        )}

        <SimpleModal
          isOpen={isOpenAdditionalResourceModal}
          toggle={additionalResourceToggle}
          bodyContent={
            <div
              dangerouslySetInnerHTML={{
                __html: exercise.additional_resource,
              }}
            />
          }
          footerContent={
            <button
              type="submit"
              class="btn btn-sm mx-3 modal-button"
              onClick={additionalResourceToggle}
            >
              Close
            </button>
          }
        />
      </Row>
      <Row  key={exercise.id} className="border border-top-0 border-bottom-0 px-4 bg-white p-3">
        {exercise.task_type === "Speaking Task" ||
        exercise.task_type === exerciseType.PRONUNCIATION_TASK ? (
          <Speaking
            speakingUrl={setSpeakingUrl}
            setIsonRecorder= {setIsonRecorder}
            data_section_id={section_id}
            data_page_id={page_id}
            answers={answers}
            resetAudio={resetAudio}
            setresetAudio={setresetAudio}
            data_exercise_id={exercise.id}
            data_type={data.type}
            speaking_data={exercise.speaking_plain_text_for_ml}
            isReview={isReview}
            speakingResponseURL={exercise.listening_file_url}
            Studentname={data.school_student_name}
          />
        ) : (
          <div>
            <ShowQuestions
              exercise_id={exercise.id}
              section_id={section_id}
              page_id={page_id}
              questions={exercise.questions}
              task_type={exercise.task_type}
              currentPage={currentPage}
              onAnswer={onblur}
              isReview={isReview}
              answer={answers}
              status={exercise.status}
              data={data}
              ai_grading_exercise={exercise.ai_grading_task}
            />
          </div>
        )}
      </Row>
      {exercise.task_type === exerciseType.WRITING_TASK ? (
        <div key={exercise.id}>
          <Row className="border border-top-0 border-bottom-0 bg-white px-4 py-2">
            <TextArea
              data-question-type="writing"
              data-tc="writitng-text"
              data-section-id={section_id}
              data-page-id={page_id}
              data-exercise-id={exercise.id}
              defaultValue={text_area_date}
              onCopy={handleCopyPaste}
              onPaste={handleCopyPaste}
              value={isReview ? exercise.answers : null}
              onchange={textarea_change}
              onBlur={onblur}
            />
          </Row>
          <p className="quiz-bottom-border mx-3"></p>
          <Row
            className="border border-top-0  border-bottom-0 bg-white px-4 py-2"
            key={`${page_id}${section_id}${exercise.id}`}
          >
              <span  className="text-muted">
                {" "}
                Words: {Answerslength === 0 ? Answerslength : wordsCounter} words{" "}
              </span>
          </Row> 
          <p className="quiz-bottom-border mx-3"></p>
        </div>
      ) : null}
    </>
  );
};
